import { html } from 'lit';
import { query, customElement } from 'lit/decorators.js';
import { WEB_COMPONENT_POLICY_PANEL_EXCHANGE_ANTIMALWARE_SETTINGS_FORM } from '../../../../../../../../../webcomponents.constants';
import { translateFn } from '../../../../../../../../../utils/translator.helper';
import { styles } from '../view/styles';
import { GzFormFieldWebComponent } from '../../../../../../../../../ui/gzForm/formField';
import { RequiredValidator } from '../../../../../../../../../ui/gzForm/validators/required.validator';
import { FormGroup } from '../../../../../../../../../ui/gzForm/formGroup/form-group';
import { GzTextareaWebComponent } from '../../../../../../../../../ui/gzInput';
import { GzPolicyFullPageWindowFormWebComponent } from '../../../../../../../../common/policyPanel/uiSettings/dialogs/fullPage/form';
import { FontSizes, FontWeights } from '../../../../../../../../../types/common/types';
import { GzCheckboxWebComponent } from '../../../../../../../../../ui/gzCheckbox';
import { ExchangeAntimalwareSettings } from '@nirvana/shared/dtos/types/policies/common';
import _ from 'lodash';
import {
  EXHANGE_ANTIMALWARE_SETTINGS_DEFAULT_VALUE,
  MAX_CHARS_SUPPORTED,
} from '../../../../../../utils/uiSettings/exchange/exchange-protection.values';

@customElement(WEB_COMPONENT_POLICY_PANEL_EXCHANGE_ANTIMALWARE_SETTINGS_FORM)
export class GzExchangeAntimalwareSettingsFormWebComponent extends GzPolicyFullPageWindowFormWebComponent<ExchangeAntimalwareSettings> {
  @query('#append-footer-field')
  appendFooterField: GzFormFieldWebComponent<GzCheckboxWebComponent>;
  @query('#footer-text-field')
  footerTextField: GzFormFieldWebComponent<GzTextareaWebComponent, string>;
  @query('#infected-text-field')
  infectedTextField: GzFormFieldWebComponent<GzTextareaWebComponent, string>;
  @query('#quarantined-text-field')
  quarantinedTextField: GzFormFieldWebComponent<GzTextareaWebComponent, string>;
  @query('#unscannable-infected-text-field')
  unscannableInfectedTextField: GzFormFieldWebComponent<GzTextareaWebComponent, string>;
  @query('#unscannable-quarantined-text-field')
  unscannableQuarantinedTextField: GzFormFieldWebComponent<GzTextareaWebComponent, string>;

  public constructor(value: ExchangeAntimalwareSettings) {
    super(value);
  }

  static get styles() {
    return styles;
  }

  public setError(error: string) {}

  protected getConvertedFormValue(): any {
    const value = _.cloneDeep(this.formGroup.value);

    // set with default value if empty
    _.set(value, ['footerText'], this.footerTextField.value || EXHANGE_ANTIMALWARE_SETTINGS_DEFAULT_VALUE.footerText);

    return value;
  }

  createFormGroup(): void {
    this.footerTextField.Validators = [RequiredValidator(translateFn('Required field'))];
    this.infectedTextField.Validators = [RequiredValidator(translateFn('Required field'))];
    this.quarantinedTextField.Validators = [RequiredValidator(translateFn('Required field'))];
    this.unscannableInfectedTextField.Validators = [RequiredValidator(translateFn('Required field'))];
    this.unscannableQuarantinedTextField.Validators = [RequiredValidator(translateFn('Required field'))];

    this.formGroup = FormGroup.build({
      appendFooter: this.appendFooterField,
      footerText: this.footerTextField,
      infectedText: this.infectedTextField,
      quarantinedText: this.quarantinedTextField,
      unscannableInfectedText: this.unscannableInfectedTextField,
      unscannableQuarantinedText: this.unscannableQuarantinedTextField,
    });
  }

  setFormGroupValue() {
    if (!this.value) {
      return;
    }

    this.formGroup.value = {
      appendFooter: this.value.appendFooter,
      footerText: this.value.footerText,
      infectedText: this.value.infectedText,
      quarantinedText: this.value.quarantinedText,
      unscannableInfectedText: this.value.unscannableInfectedText,
      unscannableQuarantinedText: this.value.unscannableQuarantinedText,
    };
  }

  /**
   * Render specific content.
   */
  protected renderContent() {
    return html`
      <div class="rules-form-container">
        <gz-form-field id="append-footer-field">
          <gz-checkbox gz-form-input @change="${e => (this.footerTextField.disabled = !e.detail.checked)}">
            <gz-title fontWeight="${FontWeights.MEDIUM}" fontSize="${FontSizes.BODY}"
              >${translateFn('Add footer to scanned emails')}
            </gz-title>
          </gz-checkbox>
        </gz-form-field>

        <gz-form-field id="footer-text-field" class="pt-2">
          <gz-textarea
            gz-form-input
            allowBeyondMaxChars
            .maxChars=${MAX_CHARS_SUPPORTED}
            placeholder="${translateFn('Type here')}"
          ></gz-textarea>
          <gz-input-error></gz-input-error>
        </gz-form-field>

        <gz-title id="footer-text-title" fontWeight="${FontWeights.MEDIUM}" fontSize="${FontSizes.BODY}" class="mt-3"
          >${translateFn('Replacement text')}</gz-title
        >
        ${this.renderTextareaWithTitle(
          translateFn('Infected file was deleted'),
          'infected-text-field',
          'infected-text-title'
        )}
        ${this.renderTextareaWithTitle(
          translateFn('Infected file was quarantined'),
          'quarantined-text-field',
          'quarantined-text-title'
        )}
        ${this.renderTextareaWithTitle(
          translateFn('Unscannable file was deleted'),
          'unscannable-infected-text-field',
          'unscannable-infected-title'
        )}
        ${this.renderTextareaWithTitle(
          translateFn('Unscannable file was quarantined'),
          'unscannable-quarantined-text-field',
          'unscannable-quarantined-title'
        )}
      </div>
    `;
  }

  private renderTextareaWithTitle(title: string, formFieldId: string, titleId: string) {
    return html`
      <gz-title id="${titleId}" fontWeight="${FontWeights.LIGHT}" fontSize="${FontSizes.PARAGRAPH_13}" class="mt-3"
        >${title}</gz-title
      >
      <gz-form-field id="${formFieldId}" class="mt-1">
        <gz-textarea
          gz-form-input
          allowBeyondMaxChars
          .maxChars=${MAX_CHARS_SUPPORTED}
          placeholder="${translateFn('Type here')}"
        ></gz-textarea>
        <gz-input-error></gz-input-error>
      </gz-form-field>
    `;
  }
}
